/**
 * Yvine Design — contact + newsletter forms (contact section, contact page,
 * footer). Cached asset, initialised once per [data-art="contact"] element.
 *
 * 1. Sending state: the native submit reloads the page, so nothing visibly
 *    happens for a moment — swap the label, spin, ignore further taps.
 * 2. Landing: Shopify reloads to …?contact_posted=true#contact_form (contact)
 *    or …?customer_posted=true#contact_form (newsletter). The browser's jump to
 *    that anchor is animated (smooth scroll) and every newsletter form on the
 *    page shows "subscribed" — so: remember which form was submitted, jump
 *    instantly to THAT form's thank-you, and drop the flags from the URL so a
 *    refresh shows the forms again.
 */
Art.section('contact', function (root) {
  var KEY = 'art_sent_form';

  // ---- Arriving from a piece -------------------------------------------
  // The gallery's "Enquire" button links here as …/pages/contact?piece=<title>.
  // Open the form with a message that already names the piece, put the form on
  // screen starting at the name field, and drop the parameter so a refresh or
  // a shared link is just the contact page.
  (function fromPiece() {
    // ?piece= from a piece's Enquire (gallery, product page), ?service= from
    // a service's "Get in touch" (services pop-up) — each with its own words.
    var m = window.location.search.match(/[?&]piece=([^&]*)/);
    var kind = 'piece';
    if (!m) { m = window.location.search.match(/[?&]service=([^&]*)/); kind = 'service'; }
    if (!m) return;
    var title = '';
    try { title = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { title = m[1]; }
    if (!title) return;

    var body = root.querySelector('#ct-body');
    var name = root.querySelector('#ct-name');
    var form = root.querySelector('#ct-contact-form');
    if (!body || !form) return;

    var tpl = root.getAttribute(kind === 'service' ? 'data-ct-service' : 'data-ct-enquiry') || '';
    // Never overwrite something already typed (a failed submit comes back
    // with the message still in the field).
    if (tpl && !body.value.trim()) body.value = tpl.replace('{{ title }}', title);

    form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    if (name) name.focus({ preventScroll: true });

    if (window.history && history.replaceState) {
      var url = window.location.pathname + window.location.search.replace(/([?&])(piece|service)=[^&]*&?/, '$1').replace(/[?&]$/, '');
      history.replaceState({}, '', url + window.location.hash);
    }
  })();

  root.querySelectorAll('form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (!btn || form.classList.contains('is-sending')) return;
      try { sessionStorage.setItem(KEY, form.id || ''); } catch (e) {}
      var label = btn.textContent;
      form.classList.add('is-sending');
      btn.setAttribute('aria-busy', 'true');
      if (btn.getAttribute('data-sending')) btn.textContent = btn.getAttribute('data-sending');
      function restore() {
        form.classList.remove('is-sending');
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      }
      // Still here after a while (captcha dismissed, network error) or shown
      // again from the back/forward cache: back to a usable button.
      setTimeout(restore, 20000);
      window.addEventListener('pageshow', restore, { once: true });
    });
  });

  var msg = root.querySelector('[data-ct-success], [data-ct-news-success]');
  if (!msg) return;
  var form = msg.closest('form');
  var sent = '';
  try { sent = sessionStorage.getItem(KEY) || ''; } catch (e) {}
  if (sent && form && form.id && sent !== form.id) return; // another form's message

  try {
    var url = new URL(location.href), dirty = false;
    ['contact_posted', 'customer_posted', 'form_type'].forEach(function (k) {
      if (url.searchParams.has(k)) { url.searchParams.delete(k); dirty = true; }
    });
    if (url.hash) { url.hash = ''; dirty = true; }
    if (dirty && history.replaceState) history.replaceState(history.state, '', url.pathname + url.search);
  } catch (e) {}

  function jump() {
    try { msg.scrollIntoView({ behavior: 'instant', block: 'center' }); }
    catch (e) { msg.scrollIntoView({ block: 'center' }); }
  }
  jump();
  requestAnimationFrame(jump);
  if (document.readyState === 'complete') setTimeout(jump, 50);
  else window.addEventListener('load', function () { jump(); setTimeout(jump, 50); });
  if (msg.focus) msg.focus({ preventScroll: true });
});
